import React, { useEffect, useState } from 'react';
import { Accessibility, X, Sun, Type, EyeOff, RotateCcw } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function AccessibilityMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const [settings, setSettings] = useState({
    highContrast: false,
    grayscale: false,
    largeText: false
  });
  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('high-contrast', settings.highContrast);
    root.classList.toggle('grayscale', settings.grayscale);
    root.classList.toggle('large-text', settings.largeText);
  }, [settings]);
  const toggleSetting = (key: keyof typeof settings) => {
    setSettings(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };
  const reset = () => {
    setSettings({
      highContrast: false,
      grayscale: false,
      largeText: false
    });
  };
  return <div className="fixed bottom-6 left-6 z-[100]" data-id="element-22">
      <button onClick={() => setIsOpen(!isOpen)} className="w-14 h-14 bg-brand-blue text-white rounded-full shadow-2xl flex items-center justify-center hover:scale-110 transition-transform focus-visible:ring-4 focus-visible:ring-blue-400 outline-none" aria-label="Open accessibility menu" aria-expanded={isOpen} data-id="element-23">
        {isOpen ? <X size={28} data-id="element-24" /> : <Accessibility size={28} data-id="element-25" />}
      </button>

      <AnimatePresence data-id="element-26">
        {isOpen && <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} className="absolute bottom-20 left-0 w-72 bg-white rounded-2xl shadow-2xl border border-gray-100 p-6" data-id="element-27">
            <h2 className="text-xl font-bold text-brand-blue mb-4 flex items-center gap-2" data-id="element-28">
              <Accessibility size={20} data-id="element-29" />
              Accessibility
            </h2>

            <div className="space-y-3" data-id="element-30">
              <button onClick={() => toggleSetting('highContrast')} className={`w-full flex items-center justify-between p-3 rounded-xl border transition-all ${settings.highContrast ? 'bg-brand-blue text-white border-brand-blue' : 'bg-gray-50 text-gray-700 border-gray-200 hover:border-brand-blue'}`} data-id="element-31">
                <span className="font-semibold flex items-center gap-2" data-id="element-32">
                  <Sun size={18} data-id="element-33" /> High Contrast
                </span>
                <div className={`w-10 h-5 rounded-full relative transition-colors ${settings.highContrast ? 'bg-white/30' : 'bg-gray-300'}`} data-id="element-34">
                  <div className={`absolute top-1 w-3 h-3 rounded-full transition-all ${settings.highContrast ? 'right-1 bg-white' : 'left-1 bg-white'}`} data-id="element-35" />
                </div>
              </button>

              <button onClick={() => toggleSetting('grayscale')} className={`w-full flex items-center justify-between p-3 rounded-xl border transition-all ${settings.grayscale ? 'bg-brand-blue text-white border-brand-blue' : 'bg-gray-50 text-gray-700 border-gray-200 hover:border-brand-blue'}`} data-id="element-36">
                <span className="font-semibold flex items-center gap-2" data-id="element-37">
                  <EyeOff size={18} data-id="element-38" /> Grayscale
                </span>
                <div className={`w-10 h-5 rounded-full relative transition-colors ${settings.grayscale ? 'bg-white/30' : 'bg-gray-300'}`} data-id="element-39">
                  <div className={`absolute top-1 w-3 h-3 rounded-full transition-all ${settings.grayscale ? 'right-1 bg-white' : 'left-1 bg-white'}`} data-id="element-40" />
                </div>
              </button>

              <button onClick={() => toggleSetting('largeText')} className={`w-full flex items-center justify-between p-3 rounded-xl border transition-all ${settings.largeText ? 'bg-brand-blue text-white border-brand-blue' : 'bg-gray-50 text-gray-700 border-gray-200 hover:border-brand-blue'}`} data-id="element-41">
                <span className="font-semibold flex items-center gap-2" data-id="element-42">
                  <Type size={18} data-id="element-43" /> Large Text
                </span>
                <div className={`w-10 h-5 rounded-full relative transition-colors ${settings.largeText ? 'bg-white/30' : 'bg-gray-300'}`} data-id="element-44">
                  <div className={`absolute top-1 w-3 h-3 rounded-full transition-all ${settings.largeText ? 'right-1 bg-white' : 'left-1 bg-white'}`} data-id="element-45" />
                </div>
              </button>

              <button onClick={reset} className="w-full flex items-center justify-center gap-2 p-3 text-gray-500 font-bold hover:text-brand-blue transition-colors mt-2" data-id="element-46">
                <RotateCcw size={16} data-id="element-47" /> Reset All
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}